export const colors = {
  // 2T5 Redesign Colours Start Here -----------------------------------------------------------------------------------
  '--bg-primary': ['#FFFFFF', '#291742'],
  '--bg-secondary': ['#EBEBEB', '#382159'],
  '--neutral-secondary': ['#EBEBEB', '#2E194C'],
  '--text-primary': ['#000000', '#FFFFFF'],
  '--text-coloured': ['#711F8B', '#FFC600'],
  '--text-inverted': ['#E9DFF5', '#000000'],
  '--text-secondary': ['#5E5E5E', '#DFCDF3'],
  '--vignette': ['#00000040', '#00000040'],
  '--link-dynamic': ['#A77AD7', '#FFC600'],

  '--monster': ['#3D0F58', '#3D0F58'],
  '--jam': ['#711F8B', '#711F8B'],
  '--wisteria': ['#A77AD7', '#A77AD7'],
  '--lavender': ['#DFCDF3', '#DFCDF3'],
  '--mikado': ['#FFC600', '#FFC600'],
  '--sandstorm': ['#FED34C', '#FED34C'],
  '--palegold': ['#FBDC70', '#FBDC70'],
  '--dusk': ['#EBEBEB', '#EBEBEB'],
  '--dawn': ['#3C3C3C', '#3C3C3C'],

  '--lilac': ['#E9DFF5', '#E9DFF5'],

  // 2T5 Schedule Colours
  '--sc-general': ['#711F8B', '#711F8B'],
  '--sc-long': ['#FFC600', '#FFC600'],
  '--sc-break': ['#A77AD7', '#A77AD7'],
  '--sc-night': ['#3C0E58', '#3C0E58'],
  '--sc-special': ['#EBEBEB', '#EBEBEB'],
  '--sc-other': ['#EBEBEB', '#EBEBEB'],
  // '--sc-highlight': ['#00000042', '#FFFFFF42'],
  '--sc-highlight': ['#00000000', '#FFFFFF00'],
  '--sc-text': ['#000000', '#3D0F58'],
  '--sc-inverted': ['#FFC600', '#FFC600'],

  // 2T5 Other Specific Components
  '--bg-footer': ['#711F8B', '#1f1033'],
  '--bg-sponsor': ['#FFFFFF', '#A77AD7'],
  '--sponsor-bronze': ['#cd7f32', '#cd7f32'],
  '--sponsor-silver': ['#c0c0c0', '#c0c0c0'],
  '--sponsor-gold': ['#FFC600', '#FFC600'],
  '--sponsor-diamond': ['#A0D8EF', '#A0D8EF'],

  // 2T4 + Earlier Colours Start Here -----------------------------------------------------------------------------------
  '--purple': ['#6f1e88', '#613480'],
  '--light-purple': ['#a04fb9', '#8c60b3'],
  '--purple-shades-dark': ['#3c0a5a', '#61347f'],
  '--purple-shades-original': ['#6f1e88', '#6f1e88'],
  '--purple-shades-muted': ['#b297c7', '#b297c7'],
  '--purple-shades-light': ['#ecd6ff', '#8c60b3'], // PleaseSponsor
  '--purple-shades-light-light': ['#efdefe', '#755096'],
  '--purple-shades-popup': ['#784786', '#382159'],
  '--yellow': ['#ffe863', '#ffcc4a'],
  '--yellow-light': ['#ffe76a', '#ffe76a'],
  '--white': ['#ffffff', '#ffffff'],
  '--on-white': ['#f3f3f3', '#C2ADD3'], // ButtonOutlined
  '--black': ['#000000', '#ffffff'],
  '--gray': ['#989898', '#989898'],
  '--shadow': ['#959da533 0px 8px 24px', '#959da533 0px 8px 24px'],
  '--green-success': ['#aad0a3', '#aad0a3'],
  '--green-success-dark': ['#56964b', '#56964b'],
  '--red-error': ['#dd4343', '#dd4343'],
  '--red-error-light': ['#ffacac', '#ffacac'],
  '--text-link': ['#FFC600', '#FED34C'],
  '--text-link-for-dark': ['#7a5f00', '#FED34C'],
  '--text-dark': ['#20002e', '#20002e'], // for a dark-text in both light and darkmode
  '--text-dark-use': ['#20002e', '#ffffff'], // use this for dark-text that changes in light and darkmode
  '--text-light': ['#f3f3f3', '#f3f3f3'],
  '--text-dynamic': ['#20002e', '#f3f3f3'],
  '--text-muted': ['#696969', '#696969'],
  '--page-bg': ['#FFFFFF', '#291742'],
  '--purple-transparent': ['#7b33a8d6', '#793DA1B8'],
  '--purple-transparent-more': ['#7b33a830', '#79409F58'],
  '--transparent': ['#00000000', '#00000000'],
  '--purple-icon-filter': [
    'invert(19%) sepia(69%) saturate(2461%) hue-rotate(270deg) brightness(82%) contrast(101%)',
    'invert(19%) sepia(69%) saturate(2461%) hue-rotate(270deg) brightness(82%) contrast(101%)',
  ],
  '--grey-icon-filter': [
    'invert(43%) sepia(0%) saturate(0%) hue-rotate(189deg) brightness(100%) contrast(88%)',
    'invert(43%) sepia(0%) saturate(0%) hue-rotate(189deg) brightness(100%) contrast(88%)',
  ],
  '--purple-bg': ['#eed8ff', '#8E6FA7'],
  '--yellow-bg': ['#ffffe4', '#92804F'],
  '--dark-purple-bg': ['#d8c0ff', '#2E2145'],
  '--gray-bg': ['#D7D2DC', '#6F6079'],
  '--green-bg': ['#e9ffe9', '#51726E'],
  '--blue-bg': ['#d2e1f7', '#424785'],
  '--magenta-bg': ['#f7d2e1', '#6E2B5B'],
  '--login-bg': ['#e8e0eb', '#e8e0eb'],
  '--gray-time-label': ['#858087', '#D6D6D6'],

  // unique colors for each component
  '--schedule-container': ['#711F8B', '#711F8B'],
  '--schedule-container-selected': ['#bca1d1', '#593875'],
  '--accordian-hover-bg': ['#00000018', '#8c60b3'],
  '--control-dot': ['#6f1e88', '#8c60b3'],

  //navbar
  '--navbar-bg': ['#FFFFFF', '#382159'], // 2T5 uses this as well
  '--navbar-link': ['#000000', '#ffffff'],
  '--navbar-underline': ['#e2e2e2', '#3C2152'],
  '--navbar-underline-desktop': ['#6f1e88', '#8c60b3'],
  '--navbar-underline-highlight': ['#6f1e88', '#8c60b3'],
  '--user-icon-bg': ['#6f1e88', '#8c60b3'],

  //button
  '--button-outlined-bg': ['#bca1d1', '#442066'],
  '--button-outlined-bg-secondary': ['#f0e6f1', '#654A7E'],
  '--button-outlined-border': ['#b297c7', '#8c60b3'],
  '--button-outlined-font': ['#20002e', '#ffffff'],
  '--button-outlined-disabled-border': ['#989898', '#8c60b3'],
  '--button-disabled': ['#BBBBBB', '#300150'],
  '--button-pressed-highlight': ['#ffffff36', '#ffffff36'],
  '--button-pressed-shadow': ['#00000052', '#00000052'], // Used in 2T5
  '--button-active-bg': ['#DFCFE6', '#7b539e'],

  //about us teams tab
  '--aboutus-tabs-color': ['#b297c7', '#b297c7'],
  '--aboutus-tabs-color-selected': ['#3c0a5a', '#ffffff'],
  '--aboutus-tabs-underline-selected': ['#b297c7', '#ffcc4a'],
  '--leedur-names': ['#ecd6ff', '#ecd6ff'],

  //faq page
  '--faq-answer-containers': ['#711F8B', '#711F8B'], // Used in 2T5
  '--faq-searchbar-bg': ['#EBEBEB', '#3D0F58'], // Used in 2T5

  //login page
  '--login-title': ['#6f1e88', '#ffffff'],
  '--forgot-message': ['#a04fb9', '#b297c7'],
  '--forgot-message-hover': ['#6f1e88', '#ffffff'],

  //text-input
  '--textinput-bg': ['#f3f3f3', '#8c60b3'],
  '--textinput-shadow-hover': ['#EBEBEB', '#8c60b3'],
  '--textinput-shadow-focus': ['#EBEBEB', '#8C64AD'],
  '--disabled': ['#F3F3F3', '#300150'],
  '--placeholder-text': ['#D2D2D2', '#A282BE'],

  //signup page, profile page bubbles, payment error page
  '--container-bg': ['#ffffff', '#613480'],
  '--resource-container-bg': ['#ffffff', '#291742'],

  //tasks and announcements
  '--task-container': ['#ffffff', '#8c60b3'], //also for timeline container
  '--task-date': ['#b297c7', '#ecd6ff'],
  '--task-check-border': ['#a04fb9', '#ecd6ff'],

  //dropdown
  '--dropdown-selected-bg': ['#ffffff', '#8c60b3'],
  '--dropdown-hover': ['#f3f3f3', '#8c60b3'],
  '--disabled-bg': ['#ffffff', '#4F2F64'],
  '--dropdown-list-border': ['#b297c7', '#8c60b3'],
  '--dropdown-list-bg': ['#ffffff', '#613480'],
  '--dropdown-list-selected': ['#b297c7', '#8c60b3'],

  //radio button and checkboxes
  '--radio-button': ['#6f1e88', '#ECE283'],

  //payment error page
  '--payment-error-text': ['#6f1e88', '#efdefe'],

  //registration success
  '--frosh-group-stroke': ['#6f1e88', '#8c60b3'],

  //scunt missions
  '--mission-bg': ['#F8F1FF', '#543570'],
  '--mission-bg-hover': ['#E3D4F1', '#835FA3'],
  '--mission-bg-active': ['#CAA9FF', '#704894'],

  //sponsor popup
  '--sponsor-container': ['#ffffff', '#8c60b3'],
  '--sponsor-background': ['#FFFFFF00', '#ffffff'],
  '--sponsor-border-diamond': [
    'radial-gradient(at 79% 31%, hsla(197,57%,55%,1) 0px, transparent 50%), radial-gradient(at 59% 87%, hsla(197,77%,81%,1) 0px, transparent 50%), radial-gradient(at 12% 87%, hsla(183,54%,54%,1) 0px, transparent 50%), radial-gradient(at 1% 62%, hsla(183,54%,54%,1) 0px, transparent 50%), radial-gradient(at 15% 12%, hsla(197,77%,81%,1) 0px, transparent 50%), radial-gradient(at 4% 97%, hsla(183,54%,54%,1) 0px, transparent 50%), radial-gradient(at 88% 35%, hsla(197,57%,55%,1) 0px, transparent 50%), radial-gradient(at 93% 58%, hsla(197,57%,55%,1) 0px, transparent 50%), radial-gradient(at 44% 12%, hsla(28,0%,87%,1) 0px, transparent 50%), radial-gradient(at 71% 96%, hsla(197,57%,55%,1) 0px, transparent 50%)',
    'radial-gradient(at 79% 31%, hsla(197,57%,55%,1) 0px, transparent 50%), radial-gradient(at 59% 87%, hsla(197,77%,81%,1) 0px, transparent 50%), radial-gradient(at 12% 87%, hsla(183,54%,54%,1) 0px, transparent 50%), radial-gradient(at 1% 62%, hsla(183,54%,54%,1) 0px, transparent 50%), radial-gradient(at 15% 12%, hsla(197,77%,81%,1) 0px, transparent 50%), radial-gradient(at 4% 97%, hsla(183,54%,54%,1) 0px, transparent 50%), radial-gradient(at 88% 35%, hsla(197,57%,55%,1) 0px, transparent 50%), radial-gradient(at 93% 58%, hsla(197,57%,55%,1) 0px, transparent 50%), radial-gradient(at 44% 12%, hsla(28,0%,87%,1) 0px, transparent 50%), radial-gradient(at 71% 96%, hsla(197,57%,55%,1) 0px, transparent 50%)',
  ],
  '--sponsor-border-gold': [
    'radial-gradient(at 41% 9%, hsla(44,78%,62%,1) 0px, transparent 50%), radial-gradient(at 60% 30%, hsla(54,69%,75%,1) 0px, transparent 50%), radial-gradient(at 15% 91%, hsla(36,64%,41%,1) 0px, transparent 50%), radial-gradient(at 15% 30%, hsla(44,78%,62%,1) 0px, transparent 50%), radial-gradient(at 90% 90%, hsla(35,84%,37%,1) 0px, transparent 50%), radial-gradient(at 80% 25%, hsla(36,62%,43%,1) 0px, transparent 50%), radial-gradient(at 10% 56%, hsla(36,62%,43%,1) 0px, transparent 50%)',
    'radial-gradient(at 41% 9%, hsla(44,78%,62%,1) 0px, transparent 50%), radial-gradient(at 60% 30%, hsla(54,69%,75%,1) 0px, transparent 50%), radial-gradient(at 15% 91%, hsla(36,64%,41%,1) 0px, transparent 50%), radial-gradient(at 15% 30%, hsla(44,78%,62%,1) 0px, transparent 50%), radial-gradient(at 90% 90%, hsla(35,84%,37%,1) 0px, transparent 50%), radial-gradient(at 80% 25%, hsla(36,62%,43%,1) 0px, transparent 50%), radial-gradient(at 10% 56%, hsla(36,62%,43%,1) 0px, transparent 50%)',
  ],
  '--sponsor-border-silver': [
    'radial-gradient(at 60% 7%, hsla(60,3%,60%,1) 0px, transparent 50%), radial-gradient(at 100% 43%, hsla(60,0%,36%,1) 0px, transparent 50%), radial-gradient(at 0% 100%, hsla(60,0%,35%,1) 0px, transparent 50%), radial-gradient(at 90% 29%, hsla(76,0%,41%,1) 0px, transparent 50%), radial-gradient(at 10% 9%, hsla(82,0%,67%,1) 0px, transparent 50%), radial-gradient(at 0% 68%, hsla(283,0%,39%,1) 0px, transparent 50%), radial-gradient(at 79% 93%, hsla(86,0%,64%,1) 0px, transparent 50%), radial-gradient(at 98% 75%, hsla(200,4%,55%,1) 0px, transparent 50%), radial-gradient(at 47% 56%, hsla(0,0%,100%,1) 0px, transparent 50%), radial-gradient(at 61% 93%, hsla(228,0%,39%,1) 0px, transparent 50%)',
    'radial-gradient(at 60% 7%, hsla(60,3%,60%,1) 0px, transparent 50%), radial-gradient(at 100% 43%, hsla(60,0%,36%,1) 0px, transparent 50%), radial-gradient(at 0% 100%, hsla(60,0%,35%,1) 0px, transparent 50%), radial-gradient(at 90% 29%, hsla(76,0%,41%,1) 0px, transparent 50%), radial-gradient(at 10% 9%, hsla(82,0%,67%,1) 0px, transparent 50%), radial-gradient(at 0% 68%, hsla(283,0%,39%,1) 0px, transparent 50%), radial-gradient(at 79% 93%, hsla(86,0%,64%,1) 0px, transparent 50%), radial-gradient(at 98% 75%, hsla(200,4%,55%,1) 0px, transparent 50%), radial-gradient(at 47% 56%, hsla(0,0%,100%,1) 0px, transparent 50%), radial-gradient(at 61% 93%, hsla(228,0%,39%,1) 0px, transparent 50%)',
  ],
  '--sponsor-border-bronze': [
    'radial-gradient(at 79% 31%, hsla(18,75%,22%,1) 0px, transparent 50%), radial-gradient(at 59% 87%, hsla(25,71%,40%,1) 0px, transparent 50%), radial-gradient(at 12% 87%, hsla(19,75%,22%,1) 0px, transparent 50%), radial-gradient(at 1% 62%, hsla(20,75%,22%,1) 0px, transparent 50%), radial-gradient(at 15% 12%, hsla(36,100%,61%,1) 0px, transparent 50%), radial-gradient(at 4% 97%, hsla(21,75%,22%,1) 0px, transparent 50%), radial-gradient(at 88% 35%, hsla(21,72%,25%,1) 0px, transparent 50%), radial-gradient(at 93% 58%, hsla(21,72%,25%,1) 0px, transparent 50%), radial-gradient(at 44% 12%, hsla(28,70%,45%,1) 0px, transparent 50%), radial-gradient(at 71% 96%, hsla(25,71%,40%,1) 0px, transparent 50%)',
    'radial-gradient(at 79% 31%, hsla(18,75%,22%,1) 0px, transparent 50%), radial-gradient(at 59% 87%, hsla(25,71%,40%,1) 0px, transparent 50%), radial-gradient(at 12% 87%, hsla(19,75%,22%,1) 0px, transparent 50%), radial-gradient(at 1% 62%, hsla(20,75%,22%,1) 0px, transparent 50%), radial-gradient(at 15% 12%, hsla(36,100%,61%,1) 0px, transparent 50%), radial-gradient(at 4% 97%, hsla(21,75%,22%,1) 0px, transparent 50%), radial-gradient(at 88% 35%, hsla(21,72%,25%,1) 0px, transparent 50%), radial-gradient(at 93% 58%, hsla(21,72%,25%,1) 0px, transparent 50%), radial-gradient(at 44% 12%, hsla(28,70%,45%,1) 0px, transparent 50%), radial-gradient(at 71% 96%, hsla(25,71%,40%,1) 0px, transparent 50%)',
  ],
  '--sponsor-border-none': [
    'linear-gradient(45deg, rgba(2,0,36,1) 0%, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 100%)',
    'linear-gradient(45deg, rgba(2,0,36,1) 0%, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 100%)',
  ],

  //scrollbar
  '--scrollbar-thumb-hover': ['#616161', '#7C508C'],
  '--scrollbar-thumb': ['#7c7c7c', '#966AA3'],
  '--scrollbar-track': ['#d3d3d3fd', '#4E3155FD'],

  '--scunt-counter-bg': ['#a04fb9', '#8c60b3'],

  '--scunt-leaderboard-bar': ['#6f1e88', '#ffcc4a'],
};
